import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import {
  CouponBatch,
  CouponBatchItem,
  CouponTypes,
} from "../../../../types/coupons";
import { AppButton } from "../../ctaButton/button";
import { useDataProvider } from "react-admin";
import {
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import HeadTable from "../../sortTable/sortTable";
import CloseIcon from "@material-ui/icons/Close";

import "./style.css";

interface Props {
  coupon: CouponBatch;
  closeModal: () => void;
  showModal: boolean;
  couponStatusType: "server" | "client";
}

export const CouponBatchViewModal = ({
  coupon,
  closeModal,
  showModal,
}: Props) => {
  const [usedCoupons, setUsedCoupons] = useState<number>(0);
  const [batchCoupons, setBatchCoupons] = useState<Array<CouponBatchItem>>([]);
  const [showCouponsList, setShowCouponsList] = useState<boolean>(false);
  const [onlyActive, setOnlyActive] = useState<boolean>(false);
  const [filteredBatchCoupons, setFilteredBatchCoupons] = useState<
    Array<CouponBatchItem>
  >([]);
  const dataProvider = useDataProvider();

  useEffect(() => {
    if (coupon) {
      getBatchCoupons();
    }
  }, [coupon]);

  useEffect(() => {
    getCountUsedCoupons();
  }, [batchCoupons]);

  useEffect(() => {
    if (onlyActive) {
      const filteredCoupons = batchCoupons.filter((coupon) => !coupon.isUsed);
      setFilteredBatchCoupons(filteredCoupons);
    } else {
      setFilteredBatchCoupons(batchCoupons);
    }
  }, [batchCoupons, onlyActive]);

  const getBatchCoupons = async () => {
    const result = (await dataProvider.getBatchCouponItems(
      "coupons/get/batchcouponitems",
      {
        _id: coupon._id,
        previousData: {} as any,
      }
    )) as any;
    if (result.data) {
      setBatchCoupons(result.data);
    }
  };

  const getCountUsedCoupons = () => {
    if (batchCoupons.length) {
      const usedCoupons = batchCoupons.filter((coupon) => coupon.isUsed);
      setUsedCoupons(usedCoupons.length);
    } else {
      setUsedCoupons(0);
    }
  };

  return (
    <div>
      {coupon && (
        <ReactModal
          onRequestClose={closeModal}
          shouldCloseOnOverlayClick={true}
          shouldCloseOnEsc={true}
          appElement={document.getElementById("root")}
          onClose={closeModal}
          isOpen={showModal}
          contentLabel="Inline Styles Modal Example"
          className="globalModalWrapper"
          style={{
            overlay: {
              backgroundColor: "rgba(9, 16, 29, 0.6)",
              zIndex: 10,
              width: "100%",
              display: "flex",
              alignItems: "center",
            },
          }}
        >
          <div className="couponModalContentWrapper">
            <div className="modalHeader">
              <span>View Batch Coupon details</span>
            </div>
            <div className="modalBody_view">
              <div className="side side_left">
                <CouponDataBlock
                  title="Coupon #"
                  allowWhitespaces={true}
                  content={coupon.title}
                />
                <CouponDataBlock
                  title="Status"
                  content={coupon.isActive ? "Active" : "Inactive"}
                />
                <CouponDataBlock title="Type" content={coupon.type} />
                {coupon.type === CouponTypes.DreamHome && coupon.raffle ? (
                  <CouponDataBlock
                    title="Title"
                    content={coupon.raffle.title}
                  />
                ) : null}
              </div>
              <div className="side side_right">
                {/* <CouponDataBlock
                  type="inline"
                  title="Date of use"
                  content={
                    coupon.dateOfUse
                      ? getDate(new Date(coupon.dateOfUse))
                      : "---"
                  }
                /> */}
                <CouponDataBlock
                  title="Basket amount"
                  content={
                    coupon.basketAmount || coupon.basketAmount === 0
                      ? "" + coupon.basketAmount / 100
                      : "---"
                  }
                />
                {coupon.discountDurationMonths && (
                  <CouponDataBlock
                    title="Coupon discount months"
                    content={
                      coupon.discountDurationMonths
                        ? "" + coupon.discountDurationMonths
                        : "---"
                    }
                  />
                )}
                <CouponDataBlock
                  title={
                    coupon.type === CouponTypes.Basket ||
                    coupon.type === CouponTypes.SubscriptionBasket ||
                    coupon.type === CouponTypes.SingleSubscription ||
                    coupon.type === CouponTypes.SingleOrder
                      ? "Discount"
                      : "Tickets"
                  }
                  content={
                    `${coupon.value} ${
                      coupon.type === CouponTypes.Basket ||
                      coupon.type === CouponTypes.SubscriptionBasket ||
                      coupon.type === CouponTypes.SingleSubscription ||
                      coupon.type === CouponTypes.SingleOrder
                        ? "%"
                        : ""
                    }` || "---"
                  }
                />
              </div>
            </div>
            <div className="modalBody_view">
              <div className="side side_left">
                <CouponDataBlock
                  title="Num of coupons"
                  allowWhitespaces={true}
                  content={coupon.limit.toString()}
                />
              </div>
              <div className="side side_right">
                <CouponDataBlock
                  title="Used coupons"
                  allowWhitespaces={true}
                  content={usedCoupons.toString()}
                />
              </div>
              <AppButton
                onClick={() => setShowCouponsList(true)}
                size="default"
                text="Coupons List"
              />
            </div>
            <div className="descriptionRow">
              <CouponDataBlock
                title="Description"
                content={coupon.description}
              />
            </div>
            <div className="modalFooter">
              <AppButton onClick={closeModal} size="long" text="Ok" />
            </div>
          </div>
        </ReactModal>
      )}
      {batchCoupons && (
        <ReactModal
          onRequestClose={() => setShowCouponsList(false)}
          shouldCloseOnOverlayClick={true}
          shouldCloseOnEsc={true}
          appElement={document.getElementById("root")}
          onClose={() => setShowCouponsList(false)}
          isOpen={showCouponsList}
          contentLabel="Inline Styles Modal Example"
          className="globalModalWrapper"
          style={{
            overlay: {
              backgroundColor: "rgba(9, 16, 29, 0.6)",
              zIndex: 10,
              width: "100%",
              display: "flex",
              alignItems: "center",
            },
          }}
        >
          <div className="couponModalContentWrapper">
            <button
              className="modal-close-btn"
              onClick={() => setShowCouponsList(false)}
            >
              <CloseIcon />
            </button>
            <div className="modalHeader">
              <span>Coupons:</span>
              <div className="modal-switch">
                <Switch
                  checked={onlyActive}
                  onChange={() => setOnlyActive(!onlyActive)}
                  color="primary"
                  name="showActive"
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
                <span>
                  {onlyActive ? "Only Active" : "All Coupons"}
                </span>
              </div>
            </div>
            <div className="modalBody_view">
              <TableContainer className="couponTableWrapper">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell key={1} className="table-cell__index">
                        <HeadTable title="#" />
                      </TableCell>
                      <TableCell>
                        <HeadTable title="Coupon ID" />
                      </TableCell>
                      <TableCell className="table-cell__index">
                        <HeadTable title="State" />
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredBatchCoupons.map((coupon, index) => {
                      return (
                        <TableRow
                          key={coupon._id}
                          className={
                            coupon.isUsed
                              ? "table-row__index--red"
                              : "table-row__index--green"
                          }
                        >
                          <TableCell className="table-cell__index">
                            {index + 1}
                          </TableCell>
                          <TableCell>{coupon.couponId}</TableCell>
                          <TableCell className="table-cell__index">
                            {coupon.isUsed ? "Used" : "Active"}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </ReactModal>
      )}
    </div>
  );
};

interface DataField {
  type?: "inline" | "default";
  title: string;
  content: string;
  allowWhitespaces?: boolean;
}
const CouponDataBlock = ({
  type,
  title,
  content,
  allowWhitespaces,
}: DataField) => (
  <div className={type === "inline" ? "row inline" : "row"}>
    <p className="fieldHeader">{title}</p>
    <p
      className={allowWhitespaces ? "fieldData allowWhitespaces" : "fieldData"}
    >
      <span>{content}</span>
    </p>
  </div>
);
